import { cn } from '@fshr/shared-react';

interface TableScrollTrackProps {
	className?: string;
	visible: boolean;
	thumbStyle: {
		width: string;
		transform: string;
	};
}

export default function TableScrollTrack({
	className,
	visible,
	thumbStyle,
}: TableScrollTrackProps) {
	return (
		<div
			className={cn(
				'relative mt-[10px] h-[5px] overflow-hidden rounded-[2px] bg-button-primary-disabled-inverse md:mt-[15px]',
				!visible && 'hidden',
				className
			)}
			aria-hidden="true"
		>
			<div
				className="absolute left-0 top-0 h-[5px] rounded-[2px] bg-text-inverse-disabled will-change-[transform,width]"
				style={thumbStyle}
			/>
		</div>
	);
}
